import axios from 'axios';
import {errorLogger} from '../errorLogger/errorLogger';

import { URL } from '../index';

export const getStoleMetaData = async () => {
    try {
        const response = await axios.get(URL.STOLE.META);

        return { data: response.data || {} };
    } catch (err) {
        return { data: undefined };
    }
}

export const getCustomerProductsById = async (id) => {
    try {
        const response = await axios.get(URL.STOLE.CUSTOMER_PRODUCTS(id));
        
        if(!response.data?.length) throw new Error('No Customer Products Data Available')

        return { data: response.data };
    } catch (err) {
        errorLogger(err.message, 'no-customer-products-data-available');
    }
}
